import { FC } from 'react';
import {
  Buttons,
  Page,
  TableWrapper,
} from '../../../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Export from '../../../../components/Export/Export';
import Table from '../../../../components/Table/Table';
import { ConfirmationProps } from './Confirmation.types';

const Confirmation: FC<ConfirmationProps> = ({ rowData }) => {

  rowData?.forEach((row) => {
    if(row.currentRawProdUsage === null) {
      row.currentRawProdUsage = 'All'
    } 
    row.updatedDate =  `${new Date(row.updatedDate).toLocaleDateString()} ${new Date(row.updatedDate).toLocaleTimeString()}`;
  })

  const columnDefs = [
    { minWidth: 120, flex: 1, wrapHeaderText: true, autoHeaderHeight: true, field: 'currentRawProdNo', headerName: 'Current RawProd'},
    { minWidth: 120, flex: 1, wrapHeaderText: true,autoHeaderHeight: true, field: 'currentRawProdDescription', headerName: 'Current Description'},
    { minWidth: 120, flex: 1, wrapHeaderText: true, autoHeaderHeight: true, field: 'currentRawProdUsage', headerName: 'Current Usage' },
    { minWidth: 120, flex: 1, wrapHeaderText: true, autoHeaderHeight: true, field: 'desiredRawProdNo', headerName: 'Desired RawProd'},
    { minWidth: 120, flex: 1, wrapHeaderText: true, autoHeaderHeight: true, field: 'desiredRawProdDescription', headerName: 'Desired Description'},
    { minWidth: 120, flex: 1, autoHeaderHeight: true, field: 'desiredRawProdUsage', headerName: 'Desired Usage' },
    { minWidth: 120, flex: 1, field: 'specNo', headerName: 'Recipe #' },
    { minWidth: 120, flex: 1, field: 'specDescription', headerName: 'Description' },
    { minWidth: 320, flex: 2, field: 'status', headerName: 'Status' },
    {
      minWidth: 220,
      flex: 1,
      field: 'updatedDate',
      headerName: 'Date/Time',
      resizable: false,
    },
  ];

  return (
    <Page data-testid='ConfirmationPage'>
      <TableWrapper>
        <Table floatingFiltersHeight={0} returnedRecords={rowData?.length} columnDefs={columnDefs} rowData={rowData} />
      </TableWrapper>
      <Buttons>
        <Export
          columnHeaders={columnDefs.map((col) => {
            return { field: col.field, headerName: col.headerName };
          })}
          rowData={rowData || []}
        />
      </Buttons>
    </Page>
  );
};

export default Confirmation;
